/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Optimization_Target_PlaceholderInputs */

const en_us2_optimization_target_placeholder = /** @type {(inputs: Optimization_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Optimization Target`)
};

const en_gb2_optimization_target_placeholder = /** @type {(inputs: Optimization_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Optimisation Target`)
};

/**
* | output |
* | --- |
* | "Select Optimization Target" |
*
* @param {Optimization_Target_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const optimization_target_placeholder = /** @type {((inputs?: Optimization_Target_PlaceholderInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Optimization_Target_PlaceholderInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_optimization_target_placeholder(inputs)
	return en_us2_optimization_target_placeholder(inputs)
});